

import React from "react";
import "../landing.css";
import HeroSection from "./HeroSection.js";
import PremiumFeatures from "./PremiumFeatures.js";
import PricingPlans from "./PricingPlans.js";
import HowItWorks from "./HowItWorks.js";

const APK_URL = "https://firebasestorage.googleapis.com/v0/b/paralight-9bf8e.firebasestorage.app/o/ParalightV8.apk?alt=media&token=88017f66-eac8-43ec-8041-fd84bc9cf9d0";
// const APK_URL = "https://firebasestorage.googleapis.com/v0/b/paralight-9bf8e.firebasestorage.app/o/ParalightV5.apk?alt=media&token=f937cd55-12c7-4fc5-a34d-cfa3e5348e85";


const LandingPage = () => {
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = APK_URL;
    link.setAttribute("download", "paralight.apk");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div>
      <HeroSection onDownload={handleDownload} />
      <PremiumFeatures />
      <PricingPlans />
      <HowItWorks />
    </div>
  );
};

export default LandingPage;
